/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import type {
  GetMyCalendarBranchMyCalendarParams,
  MyCalendarDto,
  PagedResultOfMyCalendarDto,
  SearchMyCalendarParams
} from '../models';

import { customInstance } from '../axios';



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  /**
 * @summary SearchMyCalendar
 */
export const searchMyCalendar = (
    params?: SearchMyCalendarParams,
 options?: SecondParameter<typeof customInstance<PagedResultOfMyCalendarDto>>,) => {
      return customInstance<PagedResultOfMyCalendarDto>(
      {url: `/deployment/my-calendar`, method: 'GET',
        params
    },
      options);
    }
  /**
 * @summary GetMyCalendar
 */
export const getMyCalendar = (
    id: string,
 options?: SecondParameter<typeof customInstance<MyCalendarDto>>,) => {
      return customInstance<MyCalendarDto>(
      {url: `/deployment/my-calendar/${id}/calendar`, method: 'GET'
    },
      options);
    }
  /**
 * @summary GetMyCalendarByPeriod
 */
export const getMyCalendarByPeriod = (
    year: number,
    monthId: number,
 options?: SecondParameter<typeof customInstance<MyCalendarDto>>,) => {
      return customInstance<MyCalendarDto>(
      {url: `/deployment/my-calendar/${year}/${monthId}/calendar`, method: 'GET'
    },
      options);
    }
  export const getMyCalendarBranchMyCalendar = (
    params?: GetMyCalendarBranchMyCalendarParams,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/deployment/my-calendar/branches`, method: 'GET',
        params
    },
      options);
    }
  export type SearchMyCalendarResult = NonNullable<Awaited<ReturnType<typeof searchMyCalendar>>>
export type GetMyCalendarResult = NonNullable<Awaited<ReturnType<typeof getMyCalendar>>>
export type GetMyCalendarByPeriodResult = NonNullable<Awaited<ReturnType<typeof getMyCalendarByPeriod>>>
export type GetMyCalendarBranchMyCalendarResult = NonNullable<Awaited<ReturnType<typeof getMyCalendarBranchMyCalendar>>>
